import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

interface FloursState {
  selectedProduct: string | null
}

const initialState: FloursState = {
  selectedProduct: null,
}

const floursSlice = createSlice({
  name: 'flours',
  initialState,
  reducers: {
    setSelectedProduct: (state, action: PayloadAction<string>) => {
      state.selectedProduct = action.payload
    },
    clearSelectedProduct: (state) => {
      state.selectedProduct = null
    },
  },
})

export const { setSelectedProduct, clearSelectedProduct } = floursSlice.actions

export default floursSlice.reducer
